import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

export const TrainingCampsSection = () => (
  <div className="relative mt-12 overflow-hidden rounded-3xl shadow-2xl" data-testid="training-camps-section">
    <div className="absolute inset-0 bg-gradient-to-br from-orange-50 via-amber-50 to-white"></div>
    <div className="absolute -top-32 -right-32 w-96 h-96 bg-orange-300/30 rounded-full blur-3xl"></div>
    <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-amber-300/30 rounded-full blur-3xl"></div>

    <div className="relative z-10 p-8 md:p-12 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
      <div>
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-bold shadow-lg mb-4">
          <span className="text-lg">✈️</span>
          מחנות אימונים בחו״ל
        </div>
        <h2 className="text-4xl md:text-5xl font-black text-slate-900 leading-tight mb-4">
          <span>שדרגו את המשחק</span><br />
          <span className="bg-gradient-to-r from-orange-600 to-amber-500 bg-clip-text text-transparent">
            במחנה אימונים בחו״ל
          </span>
        </h2>
        <p className="text-lg text-slate-700 leading-relaxed mb-6">
          חוויה בלתי נשכחת המשלבת אימוני טניס מקצועיים עם מאמנים מקומיים בעלי ניסיון בינלאומי,
          בליווי מאמן ישראלי לאורך כל המחנה. ימי האימון משלבים עבודה על הקורט, ניתוחי משחק, כושר
          גופני וטיולים מודרכים - בקבוצות קטנות לפי רמה, באווירה משפחתית ומקצועית.
        </p>
        <ul className="space-y-2 mb-6">
          <li className="flex items-center gap-2 text-slate-700">
            <span className="w-5 h-5 rounded-full bg-orange-500 text-white text-xs font-bold flex items-center justify-center">✓</span>
            <span>מאמנים מקומיים מקצועיים + מאמן ישראלי מלווה</span>
          </li>
          <li className="flex items-center gap-2 text-slate-700">
            <span className="w-5 h-5 rounded-full bg-orange-500 text-white text-xs font-bold flex items-center justify-center">✓</span>
            <span>אימונים יומיים, מתקנים ברמה בינלאומית</span>
          </li>
          <li className="flex items-center gap-2 text-slate-700">
            <span className="w-5 h-5 rounded-full bg-orange-500 text-white text-xs font-bold flex items-center justify-center">✓</span>
            <span>שילוב מושלם של אימון, חברה ותיירות</span>
          </li>
        </ul>
        <Link to="/training-camps" data-testid="training-camps-cta">
          <Button size="lg" className="bg-gradient-to-r from-orange-600 to-amber-500 hover:from-orange-700 hover:to-amber-600 text-white text-lg px-8 py-6 shadow-xl shadow-orange-500/30 rounded-2xl">
            ראה את כל המחנות
            <ArrowRight className="mr-2 w-5 h-5" />
          </Button>
        </Link>
      </div>
      <div className="relative">
        <div className="max-w-md mx-auto relative">
          <div className="absolute inset-0 bg-gradient-to-br from-orange-500 to-amber-500 rounded-3xl rotate-3 opacity-20"></div>
          <div className="absolute inset-0 bg-gradient-to-br from-amber-500 to-orange-500 rounded-3xl -rotate-3 opacity-20"></div>
          <div className="relative bg-white rounded-3xl p-6 shadow-2xl border-2 border-white">
            <div className="text-center mb-4">
              <div className="text-4xl mb-2">🌍</div>
              <h3 className="text-2xl font-black bg-gradient-to-r from-orange-600 to-amber-500 bg-clip-text text-transparent">
                היעדים שלנו
              </h3>
            </div>
            <div className="space-y-3">
              {[
                { flag: '🇷🇸', city: 'בלגרד', country: 'סרביה', desc: 'מסורת טניס עשירה' },
                { flag: '🇲🇪', city: 'מונטנגרו', country: 'הר השחור', desc: 'חופים והרים מרהיבים' },
                { flag: '🇦🇪', city: 'דובאי', country: 'איחוד האמירויות', desc: 'יוקרה ומתקנים מתקדמים' },
              ].map((d) => (
                <div key={d.city} className="flex items-center gap-3 p-3 rounded-xl bg-gradient-to-r from-orange-50 to-amber-50 border border-orange-100 hover:shadow-md transition-all">
                  <span className="text-3xl shrink-0">{d.flag}</span>
                  <div className="flex-1 text-right">
                    <div className="font-black text-slate-900 text-lg leading-tight">{d.city}</div>
                    <div className="text-xs text-slate-500">{d.country}</div>
                    <div className="text-xs text-orange-700 font-medium mt-0.5">{d.desc}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-4 inline-flex items-center justify-center gap-1 w-full px-4 py-2 rounded-full bg-orange-100 border border-orange-200">
              <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse"></span>
              <span className="text-orange-700 text-sm font-semibold">3 יעדים · חוויה ייחודית</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
